/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CheckoutOrderingSteps_cart$ref = any;
type CheckoutOrderingSteps_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CheckoutPage_viewer$ref: FragmentReference;
declare export opaque type CheckoutPage_viewer$fragmentType: CheckoutPage_viewer$ref;
export type CheckoutPage_viewer = {|
  +cart: ?{|
    +customer: ?{|
      +email: ?string
    |},
    +id: string,
    +order: ?{|
      +id: string,
      +orderid: ?string,
    |},
    +$fragmentRefs: CheckoutOrderingSteps_cart$ref,
  |},
  +$fragmentRefs: CheckoutOrderingSteps_viewer$ref,
  +$refType: CheckoutPage_viewer$ref,
|};
export type CheckoutPage_viewer$data = CheckoutPage_viewer;
export type CheckoutPage_viewer$key = {
  +$data?: CheckoutPage_viewer$data,
  +$fragmentRefs: CheckoutPage_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "CheckoutPage_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cart",
      "storageKey": null,
      "args": null,
      "concreteType": "Cart",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "customer",
          "storageKey": null,
          "args": null,
          "concreteType": "Customer",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "email",
              "args": null,
              "storageKey": null
            }
          ]
        },
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "order",
          "storageKey": null,
          "args": null,
          "concreteType": "Order",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "orderid",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "CheckoutOrderingSteps_cart",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "CheckoutOrderingSteps_viewer",
      "args": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '30575248b0b61f980c357e271bd2b6a7';

module.exports = node;
